import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { iconList, isImage, isPdf } from '../constants';
import { ApiService } from '../../api.service';

@Component({
	selector: 'file-icon',
	templateUrl: './file-icon.component.html',
	styleUrl: './file-icon.component.css'
})
export class FileIconComponent {
	File_Storage_URL = environment.File_Storage_URL;
	isFilePreview = false;
	previewFileType = "";
	@Input() file: any = null;
	topbar = this.apiService.getNavbar();
	isImage() {
		return isImage(this.file);
	}
	isPdf() {
		return isPdf(this.file);
	}

	constructor(private apiService: ApiService) { }

	getFileName() {
		try {
			return this.file.split("/").pop() || "";
		} catch (error) {
			return this.file;
		}
	}

	getFileExtension() {
		try {
			let ext = this.file.toLowerCase().split(".").pop();
			let obj = iconList.filter((row: any) => {
				if (row.type === ext) {
					return true;
				} else {
					return false;
				}
			});
			if (obj.length > 0) {
				let icon = obj[0].icon;
				return icon;
			} else {
				return "file";
			}
		} catch (error) {
			return "file";
		}
	}

	showFile() {
		this.previewFileType = this.isImage() ? "image" : this.isPdf() ? "pdf" : "";
		this.isFilePreview = true;
	}
}
